import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-3xl text-foreground-300"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-400">该页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}